import * as kpiConstants from '../constants/kpiConstants';

export const HEADER_KPI_ROTATION_METER_PARAMS = {
    className: "kpi-rotation-btn",
    showLabel: false,
    minRotation: kpiConstants.KPI_MIN_ROTATION,
    maxRotation: kpiConstants.KPI_MAX_ROTATION,
    svgX: kpiConstants.HEADER_KPI_ROTATION_SVG_PARAM_X_POS,
    svgY: kpiConstants.HEADER_KPI_ROTATION_SVG_PARAM_Y_POS,
    svgRadius: kpiConstants.HEADER_KPI_ROTATION_SVG_PARAM_RADIUS,
    svgStroke: kpiConstants.HEADER_KPI_ROTATION_SVG_PARAM_STROKE
};


export const TAB_KPI_ROTATION_METER_PARAMS = {
    className: "kpi-rotation-tab",
    showLabel: false,
    minRotation: kpiConstants.KPI_MIN_ROTATION,
    maxRotation: kpiConstants.KPI_MAX_ROTATION,
    svgX: kpiConstants.HEADER_KPI_ROTATION_SVG_PARAM_X_POS,
    svgY: kpiConstants.HEADER_KPI_ROTATION_SVG_PARAM_Y_POS,
    svgRadius: kpiConstants.HEADER_KPI_ROTATION_SVG_PARAM_RADIUS,
    svgStroke: kpiConstants.HEADER_KPI_ROTATION_SVG_PARAM_STROKE
};

export const DEFAULT_KPI_ROTATION_METER_PARAMS = {
    className: "kpi-rotation default",
    showLabel: true,
    minRotation: kpiConstants.KPI_MIN_ROTATION,
    maxRotation: kpiConstants.KPI_MAX_ROTATION,
    svgX: kpiConstants.DEFAULT_KPI_ROTATION_SVG_PARAM_X_POS,
    svgY: kpiConstants.DEFAULT_KPI_ROTATION_SVG_PARAM_Y_POS,
    svgRadius: kpiConstants.DEFAULT_KPI_ROTATION_SVG_PARAM_RADIUS,
    svgStroke: kpiConstants.DEFAULT_KPI_ROTATION_SVG_PARAM_STROKE,
};

export const PRIMARY_KPI_ROTATION_METER_PARAMS = {
    className: "kpi-rotation primary",
    showLabel: true,
    minRotation: kpiConstants.KPI_MIN_ROTATION,
    maxRotation: kpiConstants.KPI_MAX_ROTATION,
    svgX: kpiConstants.PRIMARY_KPI_ROTATION_SVG_PARAM_X_POS,
    svgY: kpiConstants.PRIMARY_KPI_ROTATION_SVG_PARAM_Y_POS,
    svgRadius: kpiConstants.PRIMARY_KPI_ROTATION_SVG_PARAM_RADIUS,
    svgStroke: kpiConstants.PRIMARY_KPI_ROTATION_SVG_PARAM_STROKE,
};

export const POINTS_INDICATOR_POSITIVE_SMALL ={
    value: 1,
    class:"positive-single"
};

export const POINTS_INDICATOR_POSITIVE_LARGE ={
    value: 2,
    class:"positive-double"
};

export const POINTS_INDICATOR_NEGATIVE_SMALL ={
    value: -1,
    class:"negative-single"
};

export const POINTS_INDICATOR_NEGATIVE_LARGE ={
    value: -2,
    class:"negative-double"
};

export const POINTS_INDICATOR_NEUTRAL ={
    value: 0,
    class:"no-value"
};


export const POINTS_INDICATOR_POSITIVE_SMALL_TYPE_2 ={
    value: 2,
    class:"positive-single"
};

export const POINTS_INDICATOR_POSITIVE_LARGE_TYPE_2 ={
    value: 3,
    class:"positive-double"
};

export const POINTS_INDICATOR_NEGATIVE_SMALL_TYPE_2 ={
    value: 0,
    class:"negative-single"
};

export const POINTS_INDICATOR_NEGATIVE_LARGE_TYPE_2 ={
    value: -1,
    class:"negative-double"
};

export const POINTS_INDICATOR_NEUTRAL_TYPE_2 ={
    value: 1,
    class:"no-value"
};

export const POINTS_INDICATOR_NOT_APPLICABLE ={
    value: "n-a",
    class:"n-a"
};


export const POOR_TO_RED = {
    value: "poor",
    colour: "red"
};

export const OK_TO_YELLOW = {
    value: "ok",
    colour: "yellow"
};

export const BEST_TO_GREEN = {
    value: "best",
    colour: "green"
};

export const KPI_POINTS_INDICATOR_CLASSES = [
    POINTS_INDICATOR_POSITIVE_SMALL,
    POINTS_INDICATOR_POSITIVE_LARGE,
    POINTS_INDICATOR_NEGATIVE_SMALL,
    POINTS_INDICATOR_NEGATIVE_LARGE,
    POINTS_INDICATOR_NEUTRAL,
    POINTS_INDICATOR_NOT_APPLICABLE
];

export const KPI_POINTS_INDICATOR_CLASSES_TYPE_2 = [
    POINTS_INDICATOR_POSITIVE_SMALL_TYPE_2,
    POINTS_INDICATOR_POSITIVE_LARGE_TYPE_2,
    POINTS_INDICATOR_NEGATIVE_SMALL_TYPE_2,
    POINTS_INDICATOR_NEGATIVE_LARGE_TYPE_2,
    POINTS_INDICATOR_NEUTRAL_TYPE_2,
    POINTS_INDICATOR_NOT_APPLICABLE
];

export const KPI_SELF_RATING_LIST = [
    POINTS_INDICATOR_POSITIVE_LARGE,
    POINTS_INDICATOR_POSITIVE_SMALL,
    POINTS_INDICATOR_NEUTRAL,
    POINTS_INDICATOR_NEGATIVE_SMALL,
    POINTS_INDICATOR_NEGATIVE_LARGE,
];

export const KPI_VALUES_TO_COLOUR_LIST = [
    POOR_TO_RED,
    OK_TO_YELLOW,
    BEST_TO_GREEN
];

export const KPI_SCORING_PATTERNS = [
    {
        constant: "scoring_pattern_-2,-1,0,1,2",
        indicatorClasses: KPI_POINTS_INDICATOR_CLASSES,
    },
    {
        constant: "scoring_pattern_-1,0,1,2,3",
        indicatorClasses: KPI_POINTS_INDICATOR_CLASSES_TYPE_2,
    }
];


/** WEBPACK FOOTER **
 ** ./src/models/kpiModels.js
 **/